var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkillSubmission(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.406,
    height: 19.324,
    viewBox: "0 0 16.406 19.324",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "skill-submission",
    transform: "translate(-1613.459 -204.426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20551",
    "data-name": "Group 20551",
    transform: "translate(0 41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32232",
    "data-name": "Path 32232",
    d: "M18270.641,20547.25v-12.6l-5.973-5.725h-9.428l.217,18.324h15.674",
    transform: "translate(-16641.275 -20365)",
    fill: "none",
    stroke: "#777",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32233",
    "data-name": "Path 32233",
    d: "M18263.838,20529.125v5.6h5.951",
    transform: "translate(-16640.426 -20365)",
    fill: "none",
    stroke: "#777",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10181",
    "data-name": "Rectangle 10181",
    transform: "translate(1616 212)",
    fill: "#fff",
    stroke: "#777",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 0.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 3,
    height: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_32235",
    "data-name": "Path 32235",
    d: "M18261.531,20578.438l1.287,1.432,2.631-2.312",
    transform: "translate(-16640 -20365)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32236",
    "data-name": "Path 32236",
    d: "M18261.531,20578.438l1.252,1.582,2.666-2.463",
    transform: "translate(-16639.99 -20360)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10182",
    "data-name": "Rectangle 10182",
    transform: "translate(1616 217)",
    fill: "#fff",
    stroke: "#777",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 0.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 3,
    height: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10183",
    "data-name": "Rectangle 10183",
    transform: "translate(1616 207)",
    fill: "#fff",
    stroke: "#777",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    rx: 0.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 3,
    height: 3,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillSubmission);
export default __webpack_public_path__ + "static/media/skill-submission.37de33c3978c1952b7126818e65a0f80.svg";
export { ForwardRef as ReactComponent };